// Houses first, neighborhoods last (rendered at the end)
export const neighborhoodProjects = [
  {
    id: 100,
    title: 'שכונת הכרמל',
    subtitle: 'תכנון שכונת מגורים שלמה בטבעון',
    category: 'שכונה',
    folderName: 'שכונת הכרמל טבעון',
    imageCount: 14,
    thumbnailIndex: 1,
    isNeighborhood: true,
    ribbon: 'תכנון שכונה שלמה',
  },
  {
    id: 101,
    title: 'שכונת המושבה',
    subtitle: 'תכנון שכונת מגורים שלמה ביקנעם',
    category: 'שכונה',
    folderName: 'שכונת המושבה יקענם',
    imageCount: 8,
    thumbnailIndex: 1,
    heroIndex: 6,
    isNeighborhood: true,
    ribbon: 'תכנון שכונה שלמה',
  },
];

export const projectsConfig = [
  {
    id: 1,
    title: 'הבית של זוהר',
    subtitle: 'בית קרקע באלוני אבא',
    category: 'בית קרקע',
    folderName: 'הבית של זוהר',
    imageCount: 34,
    thumbnailIndex: 5,
    heroIndex: 21,
    featured: true,
    description: 'בית קרקע באלוני אבא הבנוי סביב חצר ונושא זיכרון של ירושלים האהובה. תכנון אדריכלות ועיצוב פנים מלא.',
    credit: 'שרון צרפתי, הגר דופלט',
  },
  {
    id: 2,
    title: 'הבית של סיון',
    subtitle: 'בית דו-משפחתי בקיבוץ דברת',
    category: 'בית פרטי',
    folderName: 'הבית של סיון',
    imageCount: 34,
    thumbnailIndex: 1,
    description: 'בית קרקע דו-משפחתי בקיבוץ דברת, שתוכנן עם המון מחשבה על אור וניצול מקום, ומלא סטייל. תכנון אדריכלי ועיצוב פנים מלא.',
    credit: 'הגר דופלט',
  },
  {
    id: 3,
    title: 'הבית של גילה',
    subtitle: 'בית פרטי בקרית טבעון',
    category: 'בית פרטי',
    folderName: 'הבית של גילה',
    imageCount: 21,
    thumbnailIndex: 3,
    heroIndex: 4,
    hasBefore: true,
    beforeFolder: 'הבית של גילה לפני',
    beforeCount: 17,
    description: 'מתיחת פנים ושיפוץ מהיסוד לבית פרטי בקרית טבעון, בקווים נקיים ומלא אור. תכנון מחדש של המרחב האדריכלי ועיצוב פנים מלא.',
    credit: 'הגר דופלט',
  },
  {
    id: 4,
    title: 'הבית של גל',
    subtitle: 'בית בנחלה, עמק יזרעאל',
    category: 'נחלה',
    folderName: 'הבית של גל בנחלה',
    imageCount: 22,
    thumbnailIndex: 2,
    heroIndex: 16,
    description: 'בית פרטי בנחלה בסגנון טוסקנה בעמק יזרעאל, עם דגש על עיצוב עכשווי והתאמה למשפחה המתרחבת. תכנון אדריכלות מאפס ועיצוב פנים מלא, בשיתוף הום סטיילינג של מעצבת הפנים ליאת שמחי.',
    credit: null,
  },
  {
    id: 5,
    title: 'הבית של הילה',
    subtitle: 'בית בנחלה, עמק יזרעאל',
    category: 'נחלה',
    folderName: 'הבית של הילה בנחלה',
    imageCount: 14,
    thumbnailIndex: 3,
    heroIndex: 1,
    description: 'בית קרקע בנחלה בסגנון טוסקנה בעמק יזרעאל. תכנון בסגנון עתיק ומסורתי, מותאם אישית וללא פשרות. תכנון אדריכלי ועיצוב פנים מלא, בשיתוף הום סטיילינג של מעצבת הפנים ליאת שמחי ועל פי החלום העיצובי של הילה ברקוביץ בעלת הבית.',
    credit: null,
  },
  {
    id: 6,
    title: 'אורווה בנחלה',
    subtitle: 'אורוות סוסים, עמק יזרעאל',
    category: 'נחלה',
    folderName: 'אורווה בנחלה',
    imageCount: 7,
    thumbnailIndex: 1,
    heroIndex: 2,
    description: 'אורוות סוסים פרטית בנחלה בעמק יזרעאל - פשטות יפה כל כך, המונחית על ידי עקרונות הפרקטיקה. תכנון אדריכלי ועיצוב פנים מלא, בשיתוף סטיילינג ותכנון פרטי גמר של הילה ברקוביץ בעלת הבית.',
    credit: null,
  },
  {
    id: 7,
    title: 'הבית של ליאור',
    subtitle: 'בית פרטי באלוני אבא',
    category: 'בית פרטי',
    folderName: 'בית מוקטונת',
    imageCount: 9,
    thumbnailIndex: 2,
    description: 'בית פרטי בהרחבה של אלוני אבא, שנבנה במפלסים עם מחשבה רבה על אפשרויות ושינויים לאורך השנים עבור המשפחה המתרחבת. תכנון אדריכלי ועיצוב פנים מלא.',
    credit: 'אלעד גונן',
  },
];
